import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div `
  padding: 24px;
  flex: 1;
`;
const Exporting = () => (React.createElement(Wrapper, null,
    "Currently there are no exporters available. You can vote for your favorite framework",
    ' ',
    React.createElement("a", { href: "https://github.com/UgnisSoftware/Ugnis/issues/1" }, "here")));
export default Exporting;
